export default {
  titulo: "Delivery Notes",
  nuevo: "New delivery note",
  ver: "View delivery note",
  noHaySeries: "No serial numbers entered",
  verSeries: "View serial numbers",
  ingresarSeries: "Enter serial numbers",
  faltanSeries: "Missing serial numbers",
  msgRepuestos: "Add at least one spare part to continue",
  msgCantidad: "Enter a valid quantity",
  msgDuplicado: "Duplicate spare part",
  msgStock: "Insufficient stock",
  msgSerieInvalida: "Enter a valid serial number"
}
